module.exports = __webpack_public_path__ + "static/media/mini-placa.d1cc3035.png";